import React, { Component } from 'react';
import { Container, Row, Col, FormControl, Image, Dropdown, DropdownButton, Form, Button, Pagination, ButtonToolbar, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { store } from 'react-notifications-component';

import NavbarComponent from '../../Navbar/index';
import RenovateTokenAlert from '../../../RenovateToken';
import Backend from '../../../Backend';
import Connection from '../../../Calls';
import BackArrow from '../../../Images/arrow-left.svg';

import './index.css';

const statusTranslate={
  cancelled:'cancelada',
  pending:'pendiente',
  completed:'completada',
  incomplete:'incompleta'
}

function formatMoney(n,c,d,t){
var n = n,
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-$" : "$",
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
    j = (j = i.length) > 3 ? j % 3 : 0;
   return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
 };

let info = {email:'Correo',coin:'Cripto',address:'Direccion',terminal_name:'Source'}
class EcommerceOnboarding extends Component {
  constructor(props) {
    super(props)
    this.state = {
      cart:{
        products:[]
      },
      deposits:[],
      disabled: false,
    }
  }

  addNotification(status,msg,type){
      store.addNotification({
        title: status,
        message: msg,
        type: type,
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 2500,
          onScreen: true
        }
      });
  }

  componentDidMount(){
    this.setState({disabled: false});
    this.getOrderInfo()
  }

  getOrderInfo(){
    let { id_order } = this.props.data.match.params
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.get_order_info(response.payload.r01,id_order,response =>{
        if(response.status.code == '0'){
          let { coin , address } =  response.payload
          if(coin == 'xrp'){
            response.payload.address = address.split(':')[0]
            response.payload.tag_id = address.split(':')[1]
            info.tag_id = 'Tag ID'
          }
          this.setState({...response.payload})
        }
      })
    })
  }

  changeOrderStatus(){
    let { id_order } = this.props.data.match.params
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.change_order_status(response.payload.r01,id_order,'completed',response =>{
        if(response.status.code == '0'){
          this.addNotification("Success",'Order status has been changes',"success");
        }else{
          this.addNotification("Error!",'Something went wrong, try again later',"danger");
        }
      })
    })
  }

  renderInfo(){
    let { ecomm } = this.props.traductions
    let {state} = this;
    return Object.keys(info).map((i)=>{
      return(
        <div className='ecommerce-info-row medium-dms'>
          <span>{ecomm[i]}</span>
          <div style={{flex:1}}>
            {
              i == 'terminal_name'
              ? <p>{state[i] || 'Web'}</p>
              : <p>{state[i]}</p>
            }
          </div>
        </div>
      )
    })
  }

  renderCart(){
    let {products} = this.state.cart;
    if(!products) return
    return products.map((i)=>
      <tr>
        <td className='medium-dms gray-text'>
          {i.name}
        </td>
        <td className='medium-dms gray-text'>
          {i.quantity}
        </td>
        <td className='medium-dms gray-text'>
          {formatMoney(i.usd)} {this.state.currency || 'usd'}
        </td>
      </tr>
    )
  }

  BlockchainLinks(coin, tx) {
    switch (coin) {
      case "btc":
        return 'https://www.blockchain.com/en/btc/tx/' + tx; // + '/';
      case "ltc":
        return 'https://blockchair.com/litecoin/transaction/' + tx + '/';
      case "dash":
        return 'https://explorer.dash.org/insight/tx/' + tx + '/';
      case "eth":
        return 'https://etherscan.io/tx/' + tx;
      case "bch":
        return 'https://explorer.bitcoin.com/bch/tx/' + tx + '/';
      case "xrp":
        return 'https://livenet.xrpl.org/transactions/' + tx;
      case "usdt":
        return 'https://solscan.io/tx/' + tx;
      case "sol":
        return 'https://solscan.io/tx/' + tx;
      default:
        return '';
    }
  }

  reSendMail(){
    this.setState({disabled: true});
    let { id_order } = this.props.data.match.params
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    console.log(this.props)
    setTimeout(()=> {
      Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
        Backend.send_incomplete_order_email(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, id_order, response => {
          if(response.status.code === '0') {
            this.addNotification(`${this.props.traductions.ecomm.title_send_email_order}`,`${this.props.traductions.ecomm.send_email_order}`,"success");
          } else {
            this.addNotification(`${this.props.traductions.ecomm.title_error_send_email_order}`, `${this.props.traductions.ecomm.error_send_email_order}`, "danger");
          }
        })
      })

    }, 1000);
    setTimeout(()=> {
      this.setState({disabled: false});
    }, 5000)
  }

  renderDeposits(){
    let {deposits, coin} = this.state;
    let prev
    return deposits.map((item,i)=>{

      item.usd_amount = item.crypto_amount * item.exchange_rate
      item.missing_usd = (prev)? prev.missing_usd - item.usd_amount : this.state.amount_usd - item.usd_amount

      item.expected = (prev)?(prev.missing_usd / item.exchange_rate) : (this.state.amount_usd / item.exchange_rate)
      item.missing = item.expected - item.crypto_amount

      prev = item
      return(
        <tr>
          <td className='medium-dms blue-text underlined' onClick={()=>window.open(this.BlockchainLinks(coin,item.txid),'_blank')}>
            {item.txid}
          </td>
          <td className='medium-dms gray-text'>
            {item.created_date}
          </td>
          <td className='medium-dms gray-text'>
            {item.confirmation_date}
          </td>
          <td className='medium-dms gray-text'>
            {formatMoney(item.exchange_rate)}
          </td>
          <td className='medium-dms gray-text'>
            {item.crypto_amount}
          </td>
        </tr>
      )
    })
  }

  render(){
    let { ecomm } = this.props.traductions
    const { lan } = this.props;
    const {disabled} = this.state;
    return(
      <div>
        <NavbarComponent data={this.props} selected="ecommerce" logged={true} />
        <RenovateTokenAlert data={this.props} />
        <div className="contenedor-wallets-generals" style={{ paddingLeft: 10, paddingRight: 10 }}>

          <div>
            <div className='back-button' style={{width:110, cursor:'pointer'}} onClick={()=>this.props.data.history.push('/ecommerce')}>
              <Image src={BackArrow} style={{ marginTop:-3, marginRight:10}}/>
              {ecomm.goBack}
            </div>
          </div>
          <Row>
            <Col className='order-col' lg={5}>
              <div className='order-title-row'>
                <span className='order-title medium-dms'>{ecomm.client_info}</span>
              </div>
              <div className='container-transactions'>
                <p className='order-id'>{ecomm.order} #{this.state.reference}</p>
                <div className='order-divider'/>
                {this.renderInfo()}
              </div>
            </Col>
            <Col className='order-col' lg={7}>
              <div className='order-title-row'>
                <span className='order-title medium-dms'>{ecomm.order_details}</span>
              </div>
              <div className='container-transactions'>
                <p className='order-id'>{ecomm.order} #{this.state.reference} <span className={this.state.status}>{ecomm.status[this.state.status] || this.state.status}</span></p>
                <div className='order-divider'/>
                <table className='order-table' style={{width:'100%'}}>
                  <tr>
                    <th className='medium-dms dark-text'>
                      {ecomm.product}
                    </th>
                    <th className='medium-dms dark-text'>
                      {ecomm.quantity}
                    </th>
                    <th className='medium-dms dark-text'>
                      {ecomm.usdPrice}
                    </th>
                  </tr>
                  {this.renderCart()}
                  <tr className='order-table-bottom-row'>
                    <th>
                    </th>
                    <th className='medium-dms dark-text'>
                      Total
                    </th>
                    <th className='normal-dms blue-text'>
                      {formatMoney(this.state.cart.total)} {this.state.currency || 'usd'}
                    </th>
                  </tr>
                </table>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className='order-title-row'>
                <span className='order-title medium-dms'>{ecomm.payments}</span>
                {
                  this.state.status === 'incomplete' &&
                  <Button disabled={disabled} className='ecommerce-button' onClick={!disabled ? ()=>this.reSendMail() : null}>{this.props.traductions.ecomm.btn_send_email}</Button>
                }
                {
                  (this.state.status == 'pending' || this.state.status == 'incomplete')
                  &&
                  <Button className='ecommerce-button' onClick={()=>this.changeOrderStatus()}>{ecomm.mark_complete}</Button>
                }
              </div>
              <div className='container-transactions'>
                <table style={{width:'100%'}}>
                  <tr>
                    <th className='medium-dms dark-text'>
                      TXID
                    </th>
                    <th className='medium-dms dark-text'>
                      {ecomm.fecha}
                    </th>
                    <th className='medium-dms dark-text'>
                      {ecomm.confirm_date}
                    </th>
                    <th className='medium-dms dark-text'>
                      {ecomm.ex_value}{this.state.currency?.toUpperCase()}{lan === 'es' ? '' : ' rate' }
                    </th>
                    <th className='medium-dms dark-text'>
                      {ecomm.received}
                    </th>
                  </tr>
                  {this.renderDeposits()}
                </table>
              </div>
            </Col>
          </Row>
        </div>

      </div>
    )
  }

}
export default EcommerceOnboarding
